
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { Details, Sale } from './types';

@Component({
  components: {}
})
export default class StatisticsLicenseDetails extends Vue {
  @Prop({ type: Object as PropType<Sale>, default: () => {} })
  detail!: Details;

  mounted() {
    this.$emit('licenseValue', this.detail.License);
  }
}
